import { throwError, type Observable, type OperatorFunction } from 'rxjs';

import { type HttpErrorResponse } from '@angular/common/http';

import { type ToastService } from '@shared/ui/toast';

import { extractHttpErrorMessage } from '@shared/utils/extract-http-error-message';

import { catchHttpError } from './catch-http-error';

interface CatchWithToastOptions<R = never> {
  message: string;
  skipStatuses?: number[];
  recovery?: (err: HttpErrorResponse) => Observable<R>;
  useBackendMessage?: boolean;
}

export function catchWithToast<T, R = never>(
  toast: ToastService,
  options: CatchWithToastOptions<R>,
): OperatorFunction<T, T | R> {
  return catchHttpError((err) => {
    const shouldToast = !options.skipStatuses?.includes(err.status);

    if (shouldToast) {
      const backendMessage = options.useBackendMessage ? extractHttpErrorMessage(err) : null;
      const message = backendMessage ?? options.message;

      if (message) {
        toast.error({ summary: message });
      }
    }

    return options.recovery ? options.recovery(err) : throwError(() => err);
  });
}
